import { Typography as MuiTypography, useTheme } from '@material-ui/core'
import React from 'react'

/**
 * This component is a wrapper for Material UI Typography component.
 * The purpose: Used to extend `variant` prop to support custom variant.
 * and avoid
 * 		Warning: Failed prop type: Invalid prop `variant` of value `body3` supplied to `ForwardRef(Typography)`,
 * 		expected one of ["h1","h2","h3","h4","h5","h6","subtitle1","subtitle2","body1","body2","caption","button","overline","srOnly","inherit"].
 *
 * Current variants that are supported by Material UI Typography:
 *
 * export type Variant =
			| 'h1'
			| 'h2'
			| 'h3'
			| 'h4'
			| 'h5'
			| 'h6'
			| 'subtitle1'
			| 'subtitle2'
			| 'body1'
			| 'body2'
			| 'caption'
			| 'button'
			| 'overline';
 *
 */
export const Typography = ({ icon: Icon, children, variant, className, style, ...props }) => {
	const theme = useTheme()
	const typographyStyle = theme.typography[variant] // for default variant that supported by Material UI core v4

	return (
		<MuiTypography
			icon={Icon}
			className={`MuiTypography-${variant} ${className}`}
			variant={variant}
			style={{
				...typographyStyle,
				...style,
			}}
			{...props}
		>
			{children}
		</MuiTypography>
	)
}

export const SingleLineTypography = ({ icon: Icon, children, style, ...props }) => {
	return (
		<Typography
			icon={Icon}
			style={{
				display: 'inline-block',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				width: '100%',
				...style,
			}}
			{...props}
		>
			{children}
		</Typography>
	)
}
